import React, { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';

export default function PWAInstallPrompt() {
  const [showPrompt, setShowPrompt] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isIOS, setIsIOS] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Controlla se è già installata
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true);
      return;
    }

    // Controlla se è iOS
    const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(isIOSDevice);

    // Ascolta l'evento beforeinstallprompt (Android/Desktop)
    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      
      // Mostra il prompt dopo 30 secondi o se non è mai stato mostrato
      const lastPrompt = localStorage.getItem('pwa-prompt-dismissed');
      const now = Date.now();
      
      if (!lastPrompt || now - parseInt(lastPrompt) > 7 * 24 * 60 * 60 * 1000) {
        setTimeout(() => setShowPrompt(true), 30000);
      }
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstall);

    // Su iOS, mostra il prompt manuale dopo 30 secondi
    if (isIOSDevice) {
      const lastPrompt = localStorage.getItem('pwa-prompt-dismissed');
      const now = Date.now();
      
      if (!lastPrompt || now - parseInt(lastPrompt) > 7 * 24 * 60 * 60 * 1000) {
        setTimeout(() => setShowPrompt(true), 30000);
      }
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
    };
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      console.log('PWA install outcome:', outcome);
      setDeferredPrompt(null);
    }
    setShowPrompt(false);
  };

  const handleDismiss = () => {
    localStorage.setItem('pwa-prompt-dismissed', Date.now().toString());
    setShowPrompt(false);
  };

  if (isInstalled || !showPrompt) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 md:left-auto md:right-4 md:w-96 bg-white rounded-xl shadow-2xl border border-gray-200 p-4 z-50 animate-slide-up">
      <button
        onClick={handleDismiss}
        className="absolute top-2 right-2 p-1 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-100"
      >
        <X size={18} />
      </button>
      
      <div className="flex items-start gap-3">
        <div className="w-12 h-12 bg-black rounded-xl flex items-center justify-center flex-shrink-0">
          <img src="/icons/icon-96.png" alt="I Cirillo" className="w-10 h-10 rounded-lg" />
        </div>
        
        <div className="flex-1">
          <h3 className="font-semibold text-gray-900 text-sm">
            Installa l'App
          </h3>
          <p className="text-xs text-gray-500 mt-1">
            Aggiungi I Cirillo alla tua home per un accesso rapido
          </p>
          
          {isIOS ? (
            <div className="mt-3 text-xs text-gray-600 bg-gray-50 p-2 rounded-lg">
              <p className="font-medium mb-1">Su iPhone/iPad:</p>
              <ol className="list-decimal list-inside space-y-1">
                <li>Tocca il pulsante <span className="inline-block px-1 bg-gray-200 rounded">Condividi</span></li>
                <li>Scorri e tocca <span className="font-medium">"Aggiungi a Home"</span></li>
              </ol>
            </div>
          ) : (
            <button
              onClick={handleInstall}
              className="mt-3 w-full bg-black text-white text-sm font-medium py-2 px-4 rounded-lg hover:bg-gray-800 transition-colors flex items-center justify-center gap-2"
            >
              <Download size={16} />
              Installa Ora
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
